const TableCell = ({ info }) => {
  return (
    <div className='w-full flex justify-center m-2 min-w-[64px] text-nowrap'>
      <span>{info ? info : "N/A"}</span>
    </div>
  );
};

export default TableCell;
